/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_MissingInputs */



/**
* | output |
* | --- |
* | "Missing" |
*
* @param {Decks_MissingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_missing = /** @type {((inputs?: Decks_MissingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_MissingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Manquant")
	if (locale === "es") return /** @type {LocalizedString} */ ("Falta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Faltando")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mancante")
	return /** @type {LocalizedString} */ ("Missing")
});